export default function CenterContainer({children}) {
    return (
        <div className={"d-flex mt-5 h-100 justify-content-center align-items-center"}>
            {children}
        </div>
    );
};